import { render, staticRenderFns } from "./CuentaAliadaSidebar.vue?vue&type=template&id=29dee548&scoped=true"
import script from "./CuentaAliadaSidebar.vue?vue&type=script&lang=js"
export * from "./CuentaAliadaSidebar.vue?vue&type=script&lang=js"
import style0 from "./CuentaAliadaSidebar.vue?vue&type=style&index=0&id=29dee548&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dee548",
  null
  
)

export default component.exports